import { Typography, FormGroup, Grid, Box } from "@mui/material";
import React from "react";
import {
  IAdditionalQuestion,
  ICheckboxQuestion,
  IRateAppointment,
} from "../interface/iRateAppointment";
import { RateAppointmentContext } from "../context/rateAppointmentContext";
import CheckBoxQuestion from "./checkBoxQuestion";

const AdditionalQuestions = (): React.JSX.Element => {
  const {
    rateAppointmentDto,
  }: {
    rateAppointmentDto: IRateAppointment;
  } = React.useContext(RateAppointmentContext);

  return (
    <Box sx={{ pt: 6 }}>
      <Typography
        variant="h6"
        color="initial"
        sx={{
          mb: 1,
          fontWeight: "bold",
          color: (theme) => theme.palette.primary.main,
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        🤝 Deine Meinung ist gefragt!
      </Typography>

      <Typography
        variant="body1"
        color="initial"
        sx={{
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        Welche der folgenden Themenangebote wären für dich zusätzlich
        interessant?
      </Typography>

      <Typography
        variant="caption"
        color="initial"
        sx={{
          textAlign: { xs: "center", sm: "left" },
        }}
      >
        (Mehrfachauswahl möglich – nutze gern auch das Freitextfeld am Ende)
      </Typography>

      <FormGroup sx={{ mt: 4 }}>
        <Grid container rowSpacing={4}>
          {rateAppointmentDto.additionalQuestions.map(
            (
              additionalQuestion: IAdditionalQuestion,
              additionalQuestionIndex: number
            ) => {
              return (
                <React.Fragment key={additionalQuestionIndex}>
                  <Grid item xs={12} md={6} key={additionalQuestionIndex}>
                    <Typography
                      variant="body2"
                      color="initial"
                      sx={{
                        mb: 2,
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        textAlign: { xs: "center", sm: "left" },
                      }}
                    >
                      {additionalQuestion.section}
                    </Typography>
                    {additionalQuestion.questions.map(
                      (question: ICheckboxQuestion, questionIndex: number) => (
                        <CheckBoxQuestion
                          question={question}
                          additionalQuestionIndex={additionalQuestionIndex}
                          index={questionIndex}
                          identifier={"additionalQuestions"}
                        />
                      )
                    )}
                  </Grid>
                </React.Fragment>
              );
            }
          )}
        </Grid>
      </FormGroup>
    </Box>
  );
};

export default AdditionalQuestions;
